import { render } from "./ahu.vue?vue&type=template&id=6be54cbe&scoped=true"
const script = {}

import "./ahu.vue?vue&type=style&index=0&id=6be54cbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6be54cbe"

export default script